import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
var Auth = /** @class */ (function () {
    function Auth(http, jwtHelper) {
        this.http = http;
        this.jwtHelper = jwtHelper;
        this.onRefreshError = function () { return void 0; };
        this.tokenChange = new Subject();
        var token = Auth.token;
        try {
            if (!token || this.jwtHelper.isTokenExpired(token)) {
                return;
            }
        }
        catch (e) {
            this.logOut();
            return;
        }
        this.startRenewing();
    }
    Auth.tokenGetter = function () {
        return Auth.token;
    };
    Auth.setToken = function (token) {
        localStorage.setItem(Auth.TOKEN_NAME, token);
        localStorage.setItem(Auth.TOKEN_SET_TIME_KEY, new Date().valueOf() + '');
    };
    Object.defineProperty(Auth, "token", {
        get: function () {
            return localStorage.getItem(Auth.TOKEN_NAME);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth, "justRefreshed", {
        get: function () {
            return new Date().valueOf() - (+localStorage.getItem(Auth.TOKEN_SET_TIME_KEY)) < 5000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "user", {
        get: function () {
            return this.isLoggedIn() && this.jwtHelper.decodeToken(Auth.token).user;
        },
        enumerable: true,
        configurable: true
    });
    Auth.prototype.ngOnDestroy = function () {
        this.clearTimeout();
    };
    Auth.prototype.setOnRefreshError = function (fn) {
        this.onRefreshError = fn;
    };
    Auth.prototype.isLoggedIn = function () {
        return Auth.token && !this.jwtHelper.isTokenExpired();
    };
    Auth.prototype.doLogin = function (credentials) {
        return this.http.post(environment.api + '/auth/login', credentials)
            .map(this.handleNewTokenResponse.bind(this));
    };
    Auth.prototype.logOut = function () {
        Auth.setToken(void 0);
        localStorage.clear();
        sessionStorage.clear();
        this.emitTokenChange();
    };
    Auth.prototype.refresh = function () {
        var _this = this;
        if (Auth.justRefreshed) {
            this.startRenewing();
            return;
        }
        this.http.get(environment.api + '/auth/refresh')
            .catch(function (e) {
            _this.onRefreshError.apply(null, e);
            throw e;
        })
            .map(this.handleNewTokenResponse.bind(this))
            .subscribe();
    };
    Auth.prototype.signUp = function (user) {
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(environment.api + '/auth/signup', user, { headers: headers })
            .map(this.handleNewTokenResponse.bind(this));
    };
    Auth.prototype.changePassword = function (passwords) {
        return this.http.put(environment.api + '/auth/change', passwords)
            .map(this.handleNewTokenResponse.bind(this));
    };
    Auth.prototype.changeProfile = function (user) {
        return this.http.put(environment.api + '/auth/user', user)
            .map(this.handleNewTokenResponse.bind(this));
    };
    Auth.prototype.hasRole = function (role) {
        return this.user && this.user.roles && this.user.roles.includes(role);
    };
    Auth.prototype.hasAnyRoleOf = function () {
        var roles = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            roles[_i] = arguments[_i];
        }
        if (this.user && this.user.roles) {
            for (var _a = 0, roles_1 = roles; _a < roles_1.length; _a++) {
                var role = roles_1[_a];
                if (this.user.roles.includes(role)) {
                    return true;
                }
            }
        }
        return false;
    };
    Auth.prototype.handleNewTokenResponse = function (resp) {
        Auth.setToken(resp.token);
        this.emitTokenChange();
        this.startRenewing();
    };
    Auth.prototype.emitTokenChange = function () {
        this.tokenChange.next(this.isLoggedIn());
    };
    Auth.prototype.startRenewing = function () {
        if (!this.isLoggedIn()) {
            return;
        }
        var token = Auth.token;
        this.clearTimeout();
        var expiration = this.jwtHelper.getTokenExpirationDate(token).valueOf(), now = new Date().valueOf(), interval = Math.max(expiration - now - 30000, 0);
        this.timeout = setTimeout(this.refresh.bind(this), interval);
    };
    Auth.prototype.clearTimeout = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };
    Auth.TOKEN_NAME = 'kkk-token';
    Auth.TOKEN_SET_TIME_KEY = 'token_set_time';
    Auth.JWT_CONFIG = {
        config: {
            tokenGetter: Auth.tokenGetter,
            whitelistedDomains: [environment.backendHost]
        }
    };
    return Auth;
}());
export { Auth };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/auth.service.ts.pre-build-optimizer.js